// Presentation only: no cart storage, checkout, consent or tracking mutations.
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-r3-family-filter]')) return;
  const section = event.target.closest('.r3-section');
  let count = 0;
  section.querySelectorAll('[data-r3-family]').forEach(item => {
    item.hidden = event.target.value !== 'all' && item.dataset.r3Family !== event.target.value;
    if (!item.hidden) count++;
  });
  section.querySelector('[data-r3-filter-status]').textContent = count === 1 ? '1 product' : `${count} producten`;
});
document.addEventListener('click', (event) => {
  const photo = event.target.closest('[data-r3-photo]');
  if (photo) {
    const gallery = photo.closest('[data-r3-gallery]');
    gallery.querySelector('[data-r3-main]').src = photo.dataset.r3Photo;
    gallery.querySelector('[data-r3-main]').alt = photo.dataset.r3Alt || '';
    const caption = gallery.querySelector('[data-r3-caption]');
    if (caption) caption.textContent = photo.dataset.r3CaptionText || '';
    gallery.querySelectorAll('[data-r3-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === photo)));
  }
  document.querySelectorAll('.r3-mobile-nav[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.r3-mobile-nav[open]').forEach(menu => {
    menu.open = false; menu.querySelector('summary').focus();
  });
});
